import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { Item, Menu } from "react-contexify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ListContextMenu  extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfigure = this.handleConfigure.bind(this);
        this.handleCopy = this.handleCopy.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleConfigure = ({ event, props }) => {
        event.preventDefault();
        props.handleConfigure(props.planogramId);
    };


    handleCopy = ({ event, props }) => {
        event.preventDefault();
        props.handleCopy(props.planogramId);
    };

    handleEdit = ({ event, props }) => {
        event.preventDefault();
        props.handleEdit(props.planogramId);
    };

    handleDelete = ({ event, props }) => {
        event.preventDefault();
        props.handleDelete(props.planogramId);
    };

    render() {
        const { elementId } = this.props;

        return (
            <Menu id={elementId} animation="fade">
                <Item onClick={this.handleConfigure}>
                    <Button
                        variant="primary btn-block"
                        size="sm"
                    >
                        <FontAwesomeIcon icon="cog" /> Configure
                    </Button>
                </Item>
                <Item onClick={this.handleCopy}>
                    <Button variant="secondary btn-block" size="sm">
                        <FontAwesomeIcon icon="copy" /> Copy
                    </Button>
                </Item>
                <Item onClick={this.handleEdit}>
                    <Button variant="warning btn-block" size="sm">
                        <FontAwesomeIcon icon="pen" /> Edit
                    </Button>
                </Item>
                <Item onClick={this.handleDelete}>
                    <Button variant="danger btn-block" size="sm">
                        <FontAwesomeIcon icon="times" /> Remove
                    </Button>
                </Item>
            </Menu>
        );
    }
}

ListContextMenu.propTypes = {
    elementId: PropTypes.string.isRequired
};

export default ListContextMenu;
